import { render, staticRenderFns } from "./consolidations.vue?vue&type=template&id=b8434fc2&"
import script from "./consolidations.vue?vue&type=script&lang=ts&"
export * from "./consolidations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports